import { render } from "./DougnutChart.vue?vue&type=template&id=602618be&ts=true"
import script from "./DougnutChart.vue?vue&type=script&lang=ts"
export * from "./DougnutChart.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"symbiosy-vue-chatjs/src/charts/DougnutChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "602618be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('602618be', __exports__)) {
    api.reload('602618be', __exports__)
  }
  
  module.hot.accept("./DougnutChart.vue?vue&type=template&id=602618be&ts=true", () => {
    api.rerender('602618be', render)
  })

}


export default __exports__